import { Button, VStack } from '@ayble-health/dashboard-components';
import { FileIcon } from 'lucide-react';
import { ChartNote, ChartNoteStatus } from '../../api/types';

// Copy appended to the note label for statuses that need it.
// `chart_note_exists` gets no suffix (the note is just there to open).
const STATUS_SUFFIX: Partial<Record<ChartNoteStatus, string>> = {
  [ChartNoteStatus.TranscriptAvailable]: 'Ready',
  [ChartNoteStatus.TranscriptFailed]: 'Failed',
};

type Props = {
  chartNotes?: ChartNote[];
  onClick: (chartNote: ChartNote) => void;
};

export const UpcomingMeetingChartNotes = ({
  chartNotes = [],
  onClick,
}: Props) => {
  return (
    <VStack gap={2} mt={2}>
      {chartNotes.map((chartNote) => {
        const label = chartNote.note_label ?? chartNote.note_type;
        const isTranscribing =
          chartNote.status === ChartNoteStatus.TranscriptStarted;
        // Every status except "transcribing" (and no status) is actionable.
        const isEnabled = !!chartNote.status && !isTranscribing;
        const suffix = chartNote.status
          ? STATUS_SUFFIX[chartNote.status]
          : undefined;

        return (
          <Button
            size={'sm'}
            key={chartNote.note_id}
            variant={'outline'}
            disabled={!isEnabled}
            loading={isTranscribing}
            loadingText={'Transcribing'}
            onClick={() => onClick(chartNote)}
          >
            <FileIcon />
            {suffix ? `${label} ${suffix}` : label}
          </Button>
        );
      })}
    </VStack>
  );
};

export default UpcomingMeetingChartNotes;
